import { Button, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

import Dialog from 'modules/common/dialog.component';

function DeleteIntakeRecordDialog(props) {
  const {
    onSubmit,
    onCancel,
    ...rest
  } = props;

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit();
  };


  return (
    <Dialog
      {...rest}
      title="Cancel Intake"
      content={
        <Typography>
          Are you sure you want to cancel this intake? It will stay in the intake summary as Cancelled and can no longer be edited.
        </Typography>
      }
      actions={
        <>
          <Button onClick={onCancel} variant="outlined" color="primary">Keep Intake</Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">Cancel Intake</Button>
        </>
      }
    />
  );
}

DeleteIntakeRecordDialog.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default DeleteIntakeRecordDialog;
